import d3 from './libs/d3-lib'
import moment from 'moment-timezone'
import './libs/MiniCandleChart.js'

window.d3 = d3
window.moment = moment

export default {
  data: () => ({
    miniCsChart: null
  }),
  methods: {
    // destroy method
    miniCsDestroyEvent() {
      if (this.miniCsChart != null) {
        this.miniCsChart.destroy()
        this.miniCsChart = null
      }
    },
    newMiniCandleChart(configSettings, srcData, cbParam) {
      this.miniCsDestroyEvent()

      // var csCallbackParam = cbParam
      if (configSettings.lang) {
        window.LANGUAGE = configSettings.lang
      }
      var container = document.getElementById(configSettings.containerId)
      if (!container) return
      this.miniCsChart = new window.MiniCandleChart(configSettings)
      var data = srcData
      if (
        configSettings.symbolType === 'stk' ||
        configSettings.symbolType === 'sop'
      ) {
        data = srcData
      } else {
        data = this.csParseData(srcData)
      }
      this.miniCsChart.initDataAndUpdateAll(data)
      this.miniCsChart.setLoadMoreHistoryDataCallback(
        this.miniCsLoadHistoryCallback
      )

      return this.miniCsChart
    },
    miniCsUpdateAllData(srcData, market) {
      if (!this.miniCsChart) return
      if (!srcData || srcData.length === 0) return
      let data = srcData
      if (market === 'FUT') {
        data = this.csParseData(srcData)
      }
      this.miniCsChart.initDataAndUpdateAll(data)
    },
    miniCsUpdateNewData(srcData, market) {
      if (!this.miniCsChart) return
      if (!srcData || srcData.length === 0) return
      let data = srcData
      if (market === 'FUT') {
        data = this.csParseData(srcData)
      }
      this.miniCsChart.updateNewData(data)
    },
    miniCsLoadHistoryData(srcData, market) {
      let data = srcData
      if (market === 'FUT') {
        data = this.csParseData(srcData)
      }
      this.miniCsChart.loadMoreHistoryData(data)
    },
    miniCsSetConfig(config) {
      if (!this.miniCsChart) return
      this.miniCsChart.setConfig(config.key, config.value, config.isUpdate)
    },
    csParseData(data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      if (!data) return
      if (!data.symbol && data.contractCode) {
        data.symbol = data.contractCode
      }
      return data
    },
    miniCsUpdateLastPrice(price) {
      if (!this.miniCsChart) return
      if (!price) return
      this.miniCsChart.updateLastPrice(price)
    },
    miniCsLoadHistoryCallback(symbol, period, count) {
      // 需要加载更多历史数据时的回调函数
      this.miniLoadKLineHistory(symbol, count)
    },
    miniCsUpdataAll() {
      if (!this.miniCsChart) return
      this.miniCsChart.updateAll()
    }
  }
}
